exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animation_animation-fit_83q2u {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.animation_arrow_2fus7 {\n    position: absolute;\n    width: 41px;\n    height: 62px;\n    z-index: 1000;\n}", ""]);

// exports
exports.locals = {
	"animation-fit": "animation_animation-fit_83q2u",
	"animationFit": "animation_animation-fit_83q2u",
	"arrow": "animation_arrow_2fus7"
};